/**
 * Skatteplanering service — thin Axios wrapper for the backend
 * /:companyId/tax-planning/* endpoints (accounting/tax_planning module).
 *
 * Same conventions as YearEndService: pure functions, callers own loading
 * state and error handling. Both endpoints are admin-gated server-side
 * (403 for non-admins) and return { success, data, helpTexts } where
 * `helpTexts` is the shared plain-Swedish copy for the 3:12 owner inputs
 * (one source of truth with the agent interview — render it verbatim).
 */

import axios from './AxiosInstance';
import { getApiUrl } from '../utils/ApiUtils';

const config = { withCredentials: true };

/**
 * POST /:companyId/tax-planning/overview
 * { calendarYear, fiscalYearId?, owner?: { ownershipShare (0..1),
 *   omkostnadsbelopp, sparatUtdelningsutrymme, ytdCashSalary,
 *   narstaendeCashSalaryPrevYear, ownerEmployeeId } }
 * → { success, data: { wages, salaryGaps, periodiseringsfond?, pension,
 *     k10?, needsUserInput: [...], disclaimer, advisorFlags }, helpTexts }.
 * Sections the constants aren't seeded for come back as
 * { unavailable: <message> } instead of failing the whole overview.
 */
export async function getOverview(companyId, body) {
  const url = getApiUrl(`${companyId}/tax-planning/overview`);
  const { data } = await axios.post(url, body, config);
  return data;
}

/**
 * POST /:companyId/tax-planning/k10
 * { beskattningsar (integer), ownershipShare (0..1), omkostnadsbelopp,
 *   sparatUtdelningsutrymme?, ownCashSalaryPrevYear?,
 *   narstaendeCashSalaryPrevYear? }
 * → { success, data: { gransbelopp, rules: 'new_2026'|'old_pre2026',
 *     chosenMethod?, alternatives?, components: { ...with formula
 *     strings... }, loneunderlagSource, disclaimer }, helpTexts }.
 * 400 messages are user-facing — show them verbatim.
 */
export async function computeK10(companyId, body) {
  const url = getApiUrl(`${companyId}/tax-planning/k10`);
  const { data } = await axios.post(url, body, config);
  return data;
}
